/**
 * Tarjouskauppahaku-service.
 */
app.factory("OnlineOfferSearchService",
	["$http", "$timeout", "$rootScope", "$injector", "BrowserStorageService", function($http, $timeout, $rootScope, $injector, BrowserStorageService) {


		var self = this;
		var queryListeners = {};
		var preQueryListeners = {};
		var notificationListeners = {};
		var results = {};
		var priceRange = {
			ceil: 1010000,
			actualceil: 1000000,
			floor: 0,
			step: 10000
		};

		var buildingTypes = {
			"flat": [1,9,10],
			"rowhouse": [2,11],
			"house": [3,8,12],
			"ranch": [13],
			"lot": [5],
			"cabin": [4],
			"office": [7,14],
			"garage": [6]
		};

		var buildingTypeDescriptions = {
			"flat": "Kerros-/luhtitalo",
			"rowhouse": "Rivitalo/paritalo",
			"house": "Omakoti-/erillistalo",
			"ranch": "Maa- tai metsätila",
			"lot": "Tontti",
			"cabin": "Vapaa-ajan asunto",
			"office": "Toimitila",
			"garage": "Autotalli"
		};

		return {
			ResolveBuildingType: resolveBuildingType,
			CreateQuery: createQuery,
			RunQuery: runQuery,
			AddNotificationListener: addNotificationListener,
			RemoveNotificationListener: removeNotificationListener,
			SendNotificationToListeners: sendNotification,
			AddPreQueryListener: addPreQueryListener,
			RemovePreQueryListener: removePreQueryListener,
			AddQueryListener: addQueryListener,
			RemoveQueryListener: removeQueryListener,
			results: results,
			priceRange: priceRange
		};


		function resolveBuildingType(typeNumber) {
			for(var t in buildingTypes) {
				if(buildingTypes.hasOwnProperty(t)) {
					if(buildingTypes[t].indexOf(typeNumber) != -1) {
						return {
							"type": t,
							"description": buildingTypeDescriptions[t]
						};
					}
				}
			}
		}

		function createQuery() {
			return new QueryObject();
		}

		/**
		 * Tekee API-kutsun annetuilla hakuparametreillä
		 * @param sourceQueryObject {QueryObject}
		 * @param identifier {string} - Identifier, jolla hakutulos tallennetaan OnlineOfferSearchModeliin.
		 * @param appendResults {boolean} - appendataanko ylikirjoittamisen sijaan haettu data annettuun identifieriin.
		 * @param callback {searchQueryCallback}
		 * @param ignorePreQueryCallbacks {boolean} - skipataanko preQueryCallbackit (erikoistapaukset käyttää)
		 * @constructor
		 */
		function runQuery(sourceQueryObject, identifier, appendResults, callback, ignorePreQueryCallbacks) {
			runApiCall(sourceQueryObject, identifier, appendResults, callback, ignorePreQueryCallbacks);
		}

		/**
		 * Sisäinen funktio, ajaa itse API-kutsun.
		 * @param sourceQueryObject
		 * @param resultIdentifier
		 * @param appendResults
		 * @param callback
		 * @param ignorePreQueryCallbacks
		 */
		function runApiCall(sourceQueryObject, resultIdentifier, appendResults, callback, ignorePreQueryCallbacks) {

			// Kerätään omaksi objektiksi, koska tämä passataan preQueryListenereille,
			// ja objektina säilyy referenssi, jolloin preQueryListenerin muutokset
			// heijastuvat myös tänne puolelle.
			var paramsObj = {
				sourceQueryObject: sourceQueryObject,
				resultIdentifier: resultIdentifier,
				appendResults: appendResults,
				callback: callback
			};

			if(!ignorePreQueryCallbacks) {
				// PreQueryListenerit, suoritetaan ensin ja jos mikään ei palauta falsea, ajetaan kutsu loppuun.
				if(preQueryListeners[resultIdentifier] !== undefined) {
					for(var n = 0; n < preQueryListeners[resultIdentifier].length; n++) {
						var proceed = preQueryListeners[resultIdentifier][n](paramsObj);
						if(!proceed) {
							return;
						}
					}
				}
			}

			// Serialisoidaan API-muotoon vasta preQueryListenerien käpistelyn jälkeen.
			var query = paramsObj.sourceQueryObject.GetAsAPIQueryObject();

			// Alustetaan results ja merkataan lataus käyntiin.
			if(results[paramsObj.resultIdentifier] === undefined) {
				results[paramsObj.resultIdentifier] = {};
			}

			// If we are already loading, do not load twice
			if (results[paramsObj.resultIdentifier] && results[paramsObj.resultIdentifier].loading) {
				return;
			}

			// Set loading
			results[paramsObj.resultIdentifier].loading = true;

			// Itse API-kutsu.
			$http({
				method: 'GET',
				url: '/api/km/KM/sales',
				params: query
			}).then(function(response, status, headers, config) {
				results[paramsObj.resultIdentifier].loading = false;
				if(response.data.success) {
					var modelData = results[paramsObj.resultIdentifier];
					if(!appendResults) {
						modelData.data = response.data.data;
					}
					else {
						// Appendataan tyhjään resultsettiin, joten käytännössä sama kuin ei appendattaisi...
						if(modelData.data === undefined) {
							modelData.data = response.data.data;
						}
						else {
							for(var i = 0; i < response.data.data.results.length; i++) {
								modelData.data.results.push(response.data.data.results[i]);
							}
						}

					}

					if(typeof paramsObj.callback == 'function') {
						paramsObj.callback(true, paramsObj.resultIdentifier);
					}
					if(queryListeners[paramsObj.resultIdentifier] !== undefined) {
						for(var n = 0; n < queryListeners[paramsObj.resultIdentifier].length; n++) {
							queryListeners[paramsObj.resultIdentifier][n]();
						}
					}
				}
				else {
					console.log("response error:", response);
					if(typeof paramsObj.callback == 'function') {
						paramsObj.callback(false, paramsObj.resultIdentifier);
					}
				}
			}, function(response, status, headers, config) {
				results[paramsObj.resultIdentifier].loading = false;
				console.log("error", status, response);
				if(typeof paramsObj.callback == 'function') {
					paramsObj.callback(false, paramsObj.resultIdentifier);
				}
			});
		}

		/**
		 * Lisää query listener.
		 * Query listenerit ajetaan, aina kun query on onnistuneesti tai
		 * epäonnistuneesti suoritettu.
		 * @param resultIdentifier {string} - hakutuloksen identifier, jota halutaan kuunnella
		 * @param callback
		 * @constructor
		 */
		function addQueryListener(resultIdentifier, callback) {
			if(queryListeners[resultIdentifier] === undefined) {
				queryListeners[resultIdentifier] = [];
			}
			queryListeners[resultIdentifier].push(callback);
		}

		/**
		 * Poista query listener.
		 * @param callback
		 * @constructor
		 */
		function removeQueryListener(callback) {
			for(var identifier in queryListeners) {
				for(var i = 0; i < queryListeners[identifier].length; i++) {
					if(queryListeners[identifier][i] == callback) {
						queryListeners[identifier].splice(i, 1);
						return;
					}
				}
			}
		}

		/**
		 * PreQueryListenerit, eli listenerit, joita kutsutaan juuri ennen kuin haku suoritetaan.
		 * Täällä voidaan vielä vaikuttaa esim. haun parametreihin, tai keskeyttää haku kokonaan
		 * palauttamalla callbackista false.
		 * @param resultIdentifier
		 * @param callback {{ sourceQueryObject: {}, resultIdentifier: {string}, appendResults: {bool}, callback: {function} }}
		 * @constructor
		 */
		function addPreQueryListener(resultIdentifier, callback) {
			if(preQueryListeners[resultIdentifier] === undefined) {
				preQueryListeners[resultIdentifier] = [];
			}
			preQueryListeners[resultIdentifier].push(callback);
		}

		/**
		 * Poista PreQueryListener.
		 * @param callback
		 * @constructor
		 */
		function removePreQueryListener(callback) {
			for(var identifier in preQueryListeners) {
				for(var i = 0; i < preQueryListeners[identifier].length; i++) {
					if(preQueryListeners[identifier][i] == callback) {
						preQueryListeners[identifier].splice(i, 1);
						return;
					}
				}
			}
		}



		/**
		 * Hakuun liittyvät notifikaatiot.
		 * Ehkä huono tapa; tällä pyritään välttämään sekavat eventit, eli saman asian voisi
		 * tehdä $scope.$on(...) ja $rootScope.$broadcast(...) kombolla, mutta se on hieman
		 * sekava tapa ja huonosti backträkättävissä.
		 * @param notification
		 * @param callback
		 * @constructor
		 */
		function addNotificationListener(notification, callback) {
			if(notificationListeners[notification] === undefined) {
				notificationListeners[notification] = [];
			}
			notificationListeners[notification].push(callback);
		}

		function sendNotification(notification, data) {
			if(notificationListeners[notification]) {
				for(var i = 0; i < notificationListeners[notification].length; i++) {
					notificationListeners[notification][i](data);
				}
			}
		}

		function removeNotificationListener(callback) {
			for(var notification in notificationListeners) {
				for(var i = 0; i < notificationListeners[notification].length; i++) {
					if(notificationListeners[notification][i] == callback) {
						notificationListeners[notification].splice(i, 1);
						return;
					}
				}
			}
		}

		// -----------------------------------------------------------------------------------------------------------------

		function QueryObject() {

			var queryVersion = 2;

			/**
			 * Hintakattoa vastaava arvo, tätä käytetään mm. slidereissä. Jos max price
			 * on asetettu täksi, oletetaan, että hinnalla ei ole mitään kattoa.
			 * @type {number}
			 */
			var MAXPRICE = 1010000;

			var constraints = {};

			/**
			 * Hakutuloslimitti.
			 * @type {number}
			 */
			var limit = 30;

			/**
			 * Skip (eli offset), eli kuinka monta tulosta skipataan haun tuloksista.
			 * @type {number}
			 */
			var skip = 0;

			/**
			 * Kentät, jotka halutaan saada haussa. Käytetään, jottei haeta turhaa dataa.
			 * @type {Array}
			 */
			var fields = [];

			/**
			 * Tähän objektiin lisätään key-value-pareina custom-hakuparametrit, jos sellaisia tarvitaan.
			 * @type {Object}
			 */
			var customQueryParams = {};

			/**
			 * Lista rakennustyypeistä, joita sallitaan haussa.
			 * @type {Array}
			 */
			//var constrainedBuildingTypes = [];

			this.GetQueryVersion = function() {
				return queryVersion;
			};

			this.GetAsStorageBlob = function() {
				return {
					queryVersion: queryVersion,
					constraints: constraints,
				};
			};

			this.MergeStorageQueryBlob = function(blob) {
				if(blob.queryVersion == queryVersion) {
					queryVersion = blob.queryVersion;
					constraints = blob.constraints;
				}

				return this;
			};

			this.CloneSettingsFromAnotherQuery = function(query) {
				var blob = angular.copy(query.GetAsStorageBlob());
				this.MergeStorageQueryBlob(blob);
			};

			/**
			 * Tuplien tarkastus osoitteille.
			 * @param address
			 * @returns {boolean}
			 * @constructor
			 */
			function IsDupeAddress(address) {
				for(var i = 0; i < constraints.address.length; i++) {
					var a = constraints.address[i];
					if(angular.toJson(address) === angular.toJson(a)) {
						return true;
					}
				}
				return false;
			}

			this.clearConstraints = function() {
				constraints = {
					rooms: [
						false,
						false,
						false,
						false,
						false
					],
					address: [],
					price: {
						min: 0,
						max: MAXPRICE
					},
					buildingTypes: [],
					propertyKey: []
				};
			};

			this.clearConstraints();

			this.ResetToDefaultConstraints = function() {
				this.clearConstraints();
			};

			this.GetConstraints = function() {
				return constraints;
			};


			// ---------------------------------------------------------------------------------------
			// Huonelukumäärät
			// ---------------------------------------------------------------------------------------

			this.SetRoomConstraint = function(roomAmount, constrained) {
				if(roomAmount <= constraints.rooms.length && roomAmount > 0) {
					constraints.rooms[roomAmount-1] = constrained;
				}
			};

			this.GetRoomConstraints = function() {
				return constraints.rooms;
			};

			this.GetRoomConstraint = function(roomAmount) {
				return constraints.rooms[roomAmount - 1];
			};


			// ---------------------------------------------------------------------------------------
			// Rakenntuksen tyyppirajoitteet
			// ---------------------------------------------------------------------------------------

			this.SetBuildingTypeConstraint = function(buildingType, constrained) {
				if(buildingTypes[buildingType] !== undefined) {
					var typeIndex = constraints.buildingTypes.indexOf(buildingType);
					if(typeIndex == -1 && constrained) {
						constraints.buildingTypes.push(buildingType);
					}
					else if(typeIndex != -1 && !constrained) {
						constraints.buildingTypes.splice(typeIndex, 1);
					}
				}
			};

			this.GetBuildingTypeConstraint = function(buildingType) {
				return constraints.buildingTypes.indexOf(buildingType) != -1;
			};

			this.ToggleBuildingTypeConstraint = function(buildingType) {
				if(constraints.buildingTypes.indexOf(buildingType) == -1) {
					this.SetBuildingTypeConstraint(buildingType, true);
				}
				else {
					this.SetBuildingTypeConstraint(buildingType, false);
				}
			};


			// ---------------------------------------------------------------------------------------
			// Osoiterajoitteet
			// ---------------------------------------------------------------------------------------

			this.AddAddressConstraint = function(addressConstraint) {
				if(!IsDupeAddress(addressConstraint)) {
					constraints.address.push(addressConstraint);
				}
			};

			this.RemoveAddressConstraint = function(index) {
				constraints.address.splice(index, 1);
			};

			this.GetAddressConstraints = function() {
				return constraints.address;
			};

			// ---------------------------------------------------------------------------------------
			// Hintarajoitus
			// ---------------------------------------------------------------------------------------

			this.SetPriceConstraint = function(min, max) {
				constraints.price.min = min;
				constraints.price.max = max;
			};

			this.GetPriceConstraints = function() {
				return constraints.price;
			};


			// ---------------------------------------------------------------------------------------
			// Limit ja skip
			// ---------------------------------------------------------------------------------------

			this.SetResultLimit = function(count) {
				limit = count;
			};

			this.GetResultLimit = function() {
				return limit;
			};

			this.SetSkip = function(skipCount) {
				skip = skipCount;
			};

			this.GetSkip = function() {
				return skip;
			};

			// ---------------------------------------------------------------------------------------
			// Rajoitetaan haettavaa dataa
			// ---------------------------------------------------------------------------------------

			this.SetDataFields = function(fieldArray) {
				fields = [];
				for(var i = 0; i < fieldArray.length; i++) {
					fields.push(fieldArray[i]);
				}
			};

			this.GetDataFields = function() {
				return fields;
			};

			/**
			 * Luo finaalimuotoisen query-objektin, joka voidaan syöttää suoraan API-kutsulle
			 * datana. Kootaan kaikki queryn parametrit API:lle sopivaan muotoon.
			 * Jos arvo on default, sitä ei erikseen aseteta.
			 */
			this.GetAsAPIQueryObject = function() {

				var apiQuery = {
					limit: limit
				};

				ParseQueryParameters(apiQuery);
				ParseCustomQueryParameters(apiQuery);

				return apiQuery;
			};

			this.AddCustomQueryParameter = function(key, value) {
				customQueryParams[key] = value;
			};

			this.AddCustomQueryParameters = function(params) {
				for(var key in params) {
					this.AddCustomQueryParameter(key, params[key]);
				}
			};

			/**
			 * Parsee parametrit
			 * @param apiQuery {object} - API-query objekti, johon parsitut parametrit sijoitetaan
			 */
			function ParseQueryParameters(apiQuery) {

				var i, j, r;
				// Otetaan tyhjä query oletusarvojen vertailua varten.
				var defaultValues = new QueryObject();


				// min: int, minimivuokra
				if(constraints.price.min != defaultValues.GetPriceConstraints().min) {
					apiQuery.min = constraints.price.min;
				}

				// max: int, maksimivuokra
				if(constraints.price.max != defaultValues.GetPriceConstraints().max) {
					apiQuery.max = constraints.price.max;
				}

				// rooms: array of int, huoneiden lukumäärä (roomAmount)
				for(r = 1; r <= constraints.rooms.length; r++) {
					if(constraints.rooms[r-1]) {
						if(typeof apiQuery['rooms[]'] == 'undefined') {
							apiQuery['rooms[]'] = [];
						}
						apiQuery['rooms[]'].push(r);
					}
				}

				// Osoitteet / hakualueet
				if(constraints.address.length > 0) {
					apiQuery['query[]'] = [];
					for(i = 0; i < constraints.address.length; i++) {
						apiQuery['query[]'].push(JSON.stringify(constraints.address[i].query));
					}
				}

				if(constraints.buildingTypes.length > 0) {
					apiQuery['buildingType[]'] = [];
					for(i = 0; i < constraints.buildingTypes.length; i++) {
						var typeNumbers = buildingTypes[constraints.buildingTypes[i]];
						for(j = 0; j < typeNumbers.length; j++) {
							apiQuery['buildingType[]'].push(typeNumbers[j]);
						}
					}
				}

				// Skip
				if(skip > 0) {
					apiQuery.skip = skip;
				}

				// Fields
				if(fields.length > 0) {
					var f = {};
					for(j = 0; j < fields.length; j++) {
						f[fields[j]] = 1;
						apiQuery.fields = JSON.stringify(f);
					}
				}
			}

			/**
			 * Parsii custom parametrit customQueryParams-objektista
			 * ja lisää ne API-querylle.
			 * @param constraintData
			 * @param apiQuery
			 */
			function ParseCustomQueryParameters(apiQuery) {
				for(var key in customQueryParams) {
					apiQuery[key] = customQueryParams[key];
				}
			}

		} // end QueryObject


	}]
);